import { render, staticRenderFns } from "./addCategoryComponent.vue?vue&type=template&id=4ba86d40"
import script from "./addCategoryComponent.vue?vue&type=script&lang=js"
export * from "./addCategoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports